import onClick from "@/js/libs/onClick";

let APP = window.APP || {};

document.addEventListener("DOMContentLoaded", function () {
  const body = document.querySelector("body");
  const hamburger = document.querySelector("#hamburger");
  const navigation = document.querySelector("#navigation");

  if (!hamburger || !navigation) {
    return;
  }

  APP.sidebar = {
    close: function () {
      this.isOpen = false;

      window.dispatchEvent(new CustomEvent('sidebar', { detail: false }));

      body.setAttribute("data-sidebar", "closed");
      hamburger.setAttribute("aria-pressed", "false");
      navigation.setAttribute("aria-hidden", "true");

      APP.locked = false;
      APP.scrollHeaderTicking = false;
    },

    open: function () {
      this.isOpen = true;

      if (APP.resetStickyHeader) {
        APP.resetStickyHeader();
      }

      window.dispatchEvent(new CustomEvent("sidebar", { detail: true }));

      body.setAttribute("data-sidebar", "open");
      hamburger.setAttribute("aria-pressed", "true");
      navigation.setAttribute("aria-hidden", "false");

      // stop scrolling
      APP.locked = true;
    },

    toggle: function () {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },

    isOpen: false,
  };

  if (APP.media.matches("mobilemenu")) {
    APP.sidebar.close();
  }

  onClick(".Overlay", function () {
    APP.sidebar.close();
  });

  onClick(hamburger, function (e) {
    e.preventDefault();
    this.blur();
    APP.sidebar.toggle();
  });
});
